// extracted by mini-css-extract-plugin
module.exports = {"root":"Calendar_root__jIejm","navButton":"Calendar_navButton__1GX1O","next":"Calendar_next__1lzEg","previous":"Calendar_previous__3vGHu","iconArrow":"Calendar_iconArrow__PSgXp"};